import { CustomButton, SelectDropDown, SvgFilledCross } from '@ui-kit'
import { PERMISSION_ASSIGNMENT } from '../../utils/constants'
import {
  addToaster,
  PermissionSetWithoutPermissionsType,
  useDispatch,
} from '@app-store'
import { AssignPermissionSetRightPanelProps } from '../../types/permissionAssignment.types'
import { uniqueId } from 'lodash'
import { ShortcutKeys, TAB_INDEX_DEFAULT } from '../../constants/form.constants'

export const AssignPermissionSetRightPanel = ({
  selectedPermissionSets,
  handleClearChip,
  handleAddProgram,
  handleClearProgram,
  selectedProgram,
  handleProgramChange,
  programOptions,
}: AssignPermissionSetRightPanelProps) => {
  const dispatch = useDispatch()

  const validateAssignedPermissionSet = (
    program: string,
    permission_sets: PermissionSetWithoutPermissionsType[]
  ) => {
    if (!program) {
      dispatch(
        addToaster({
          id: uniqueId(),
          type: 'error',
          message: PERMISSION_ASSIGNMENT.PROGRAM_REQUIRED_MESSAGE,
        })
      )
      return false
    } else if (!permission_sets?.length) {
      dispatch(
        addToaster({
          id: uniqueId(),
          type: 'error',
          message: PERMISSION_ASSIGNMENT.PERMISSION_SET_REQUIRED_MESSAGE,
        })
      )
      return false
    }
    return true
  }

  const handleAddProgramClick = () => {
    const program = selectedProgram?.program_name ?? ''
    const isValid = validateAssignedPermissionSet(
      program,
      selectedPermissionSets
    )

    if (isValid && selectedProgram) {
      handleAddProgram({
        program_id: selectedProgram.program_id,
        program_name: program,
        permission_sets: selectedPermissionSets,
        enabled: true,
      })
      handleClearProgram()
    }
  }

  return (
    <div className="flex flex-1 min-w-0 flex-col gap-3 border rounded border-border-100 p-4">
      <div className="flex justify-between gap-2 items-center">
        <div className="w-1/3">
          <SelectDropDown
            label={PERMISSION_ASSIGNMENT.PROGRAM}
            options={programOptions}
            name={'program'}
            onChange={handleProgramChange}
            required={true}
            dataQaId={'program-name'}
            defaultValue={selectedProgram?.program_id}
            customLabelIndex={0}
          />
        </div>
        <div className="flex  gap-1 items-center">
          <span
            className="py-2 px-4 cursor-pointer text-sm"
            data-qa-id="permission-set-clear-button"
            onClick={handleClearProgram}
          >
            {PERMISSION_ASSIGNMENT.CLEAR}
          </span>
          <CustomButton
            className="w-full"
            dataQaId="permission-set-add-button"
            onClick={handleAddProgramClick}
          >
            {PERMISSION_ASSIGNMENT.ADD_BUTTON}
          </CustomButton>
        </div>
      </div>
      <div className="flex-1 min-h-0 rounded p-3 custom-shadow">
        <div className=" w-full h-full px-2.5 py-3 border rounded border-border-100">
          <div className="flex flex-wrap items-start gap-2.5 ">
            {selectedPermissionSets?.map((permissionSet, index) => {
              return (
                <div
                  key={`${permissionSet.permission_set_id}_${index}`}
                  className="bg-secondary-50 text-accent-500 flex justify-center items-center  py-1 px-2 rounded-full gap-0.5"
                  data-qa-id={`selected-permission-${permissionSet.permission_set_name}`}
                >
                  <span className={`text-xs/5 font-primary text-accent-800`}>
                    {permissionSet.permission_set_name}
                  </span>
                  <span
                    className="p-[0.0625rem]"
                    data-qa-id={'clear-permission-set-chip'}
                    onClick={(e) => {
                      handleClearChip(permissionSet.permission_set_id)
                      e.stopPropagation()
                    }}
                    tabIndex={TAB_INDEX_DEFAULT}
                    onKeyDown={(e) => {
                      if (
                        e?.key === ShortcutKeys.Enter ||
                        e?.key === ShortcutKeys.Space
                      ) {
                        handleClearChip(permissionSet.permission_set_id)
                        e.stopPropagation()
                        e?.preventDefault()
                      }
                    }}
                  >
                    <SvgFilledCross
                      width={'15'}
                      height={'15'}
                      className="svg-path-fill-accent-500"
                    />
                  </span>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
}
